<stages-dialog2 #dialog
	><stages-dialog-header />
	<h1 translate="files.cms.oauth.success"></h1>
	<p class="panel" translate="files.cms.oauth.success.standby"></p>
	<stages-spin size="md" />
	<footer></footer>
</stages-dialog2>
